/**
 * Inicio del evento en el cliente: `date` (YYYY-MM-DD o ISO) + timeStart/time/horaInicio.
 * Alineado con la lógica del backend (evento-inicio.util.ts).
 */

const HORA_RE = /^(\d{1,2}):(\d{2})/;

function parseWallClock(timeStr) {
  const raw = (timeStr && String(timeStr).trim()) || '00:00';
  const m = raw.match(HORA_RE);
  if (!m) return { h: 0, min: 0 };
  return {
    h: Math.min(23, Math.max(0, parseInt(m[1], 10))),
    min: Math.min(59, Math.max(0, parseInt(m[2], 10))),
  };
}

/** `date` puede ser "YYYY-MM-DD" o ISO; devuelve ms del inicio local. */
export function getEventoInicioTimestampMs(evento) {
  const dateStr = evento?.date || evento?.fecha;
  if (!dateStr) return 0;
  const day = String(dateStr).split('T')[0];
  const [y, mo, d] = day.split('-').map((x) => parseInt(x, 10));
  if (!y || !mo || !d) return 0;
  const t = evento.timeStart || evento.time || evento.horaInicio || evento.hora || '';
  const { h, min } = parseWallClock(t);
  return new Date(y, mo - 1, d, h, min, 0, 0).getTime();
}

/** Fin del evento (ms) usando timeEnd/horaFin si existe; si no, cae al inicio. */
export function getEventoFinTimestampMs(evento) {
  const dateStr = evento?.date || evento?.fecha;
  if (!dateStr) return 0;
  const day = String(dateStr).split('T')[0];
  const [y, mo, d] = day.split('-').map((x) => parseInt(x, 10));
  if (!y || !mo || !d) return 0;
  const tEnd = evento.timeEnd || evento.horaFin || '';
  const rawEnd = (tEnd && String(tEnd).trim()) || '';
  if (!rawEnd) return getEventoInicioTimestampMs(evento);
  const { h, min } = parseWallClock(rawEnd);
  const endMs = new Date(y, mo - 1, d, h, min, 0, 0).getTime();
  const startMs = getEventoInicioTimestampMs(evento);
  if (endMs < startMs) {
    return endMs + 24 * 60 * 60 * 1000;
  }
  return endMs;
}

export function isEventoInicioPasado(evento, nowMs = Date.now()) {
  const st = getEventoInicioTimestampMs(evento);
  if (!st) return false;
  return st <= nowMs;
}

export function isEventoFinPasado(evento, nowMs = Date.now()) {
  const et = getEventoFinTimestampMs(evento);
  if (!et) return false;
  return et <= nowMs;
}

export function isEventoInicioFuturo(evento, nowMs = Date.now()) {
  const st = getEventoInicioTimestampMs(evento);
  if (!st) return true;
  return st > nowMs;
}

/** Tratar como finalizado en UI: backend `completed` o ya pasó el fin (p. ej. antes del cron). */
export function isEventoEfectivamenteFinalizado(evento) {
  const s = (evento?.status || '').toLowerCase();
  if (s === 'completed') return true;
  if (s === 'cancelled') return false;
  return isEventoFinPasado(evento);
}
